import { Select, type SelectProps } from "./Select";

export type BasicSelectProps = SelectProps;

export function BasicSelect(props: BasicSelectProps): JSX.Element {
  return <Select {...props} />;
}
